module.exports = __webpack_public_path__ + "img/ylb-11.ce6fced9.png";